// extracted by mini-css-extract-plugin
module.exports = {"truncateable":"_2fYAeLQksIvg3CqvZ6T-h","expand-section":"G5BkaCs2I-Y4xxsUbLouU","bottom-placeholder":"_3f0f3drVQFV5yB5MWgb1Rn","expand-icon":"_2RljeUSLBPupcudJ31XL5T"};